export default __webpack_public_path__ + "static/media/Information_icon.2fad109e.svg";